import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { map, switchMap } from 'rxjs';
import { RouterQuery } from "@datorama/akita-ng-router-store";
import { WeatherStore, WeatherState } from './weather.store';

@Injectable({ providedIn: "root" })
export class WeatherQuery extends QueryEntity<WeatherState> {
  public weathers$ = this.selectAll();
  public weather$ = this.routerQuery
    .selectParams('id')
    .pipe(
      switchMap((id) => this.selectEntity(id))
    );

  constructor(protected store: WeatherStore, public routerQuery: RouterQuery) {
    super(store);
  }

}

